import type {
  InitialFormValues,
  QueryParameters,
} from '../../queries/schema/carFinance.schema';
import { BankOfIrelandFinanceForm } from '../../financeProviders/bankofireland/BankOfIrelandForm';
import { CloseBrothersFinanceForm } from '../../financeProviders/closebrothers/CloseBrothersForm';

type SwitchOnProviderProps = {
  query: QueryParameters;
  onSubmitCallback: () => void;
  onSubmitErrorCallback: (errorFields: Array<string>) => void;
  onStepChange?: (step: number) => void;
  initialFormData: InitialFormValues;
  adId: string;
  make: string;
  model: string;
  provider: string;
  price: number;
};

/**
 * Each provider has their own form as there are variations in fields and requirements between them.
 * Any new provider should be added here as a new case.
 */
const SwitchOnProvider = (props: SwitchOnProviderProps) => {
  const {
    query: { provider },
  } = props;
  switch (provider) {
    case 'bankofireland':
      return <BankOfIrelandFinanceForm {...props} />;
    case 'closebrothers':
      return <CloseBrothersFinanceForm {...props} />;
    default:
      return null;
  }
};

export { SwitchOnProvider };
